import {
  setCheckButtons,
  setTableButtons,
  setFormButtons
} from '@/utils/getbuttons.js'

function parseManuals(raw) {
  if (Array.isArray(raw)) return raw
  if (raw == null || raw === '') return []
  if (typeof raw === 'string') {
    const text = raw.trim()
    if (!text || text === '[]' || text === 'null') return []
    try {
      const parsed = JSON.parse(text)
      return Array.isArray(parsed) ? parsed : []
    } catch (e) {
      return []
    }
  }
  return []
}

function manualsToFileList(raw, baseURL, uploadfile) {
  return parseManuals(raw)
    .map((item, index) => {
      const fileUid = item.fileUid || item.uid || ''
      const name = item.name || item.fileName || '手册' + (index + 1)
      if (!fileUid) return null
      const url =
        item.url && String(item.url).indexOf('http') === 0
          ? item.url
          : (baseURL || '') +
            (uploadfile || '/static/files/file') +
            '/' +
            fileUid
      return {
        name: name,
        uid: fileUid,
        fileUid: fileUid,
        url: url,
        status: 'success',
        fileType: item.fileType || ''
      }
    })
    .filter(Boolean)
}

function manualsFromForm(form) {
  const lists =
    (form && form.fileLists && form.fileLists.userManuals) ||
    (form && form.userManualsFiles) ||
    []
  const arr = Array.isArray(lists) ? lists : []
  return arr
    .map((item) => {
      const fromRes =
        item.response &&
        item.response.data &&
        (item.response.data.fileUid || item.response.data.imageId)
      let fileUid = fromRes || item.fileUid || ''
      if (!fileUid && item.uid && /^[0-9a-f-]{20,}$/i.test(String(item.uid))) {
        fileUid = item.uid
      }
      const name = item.name || item.fileName || ''
      if (!fileUid || !name) return null
      let fileType = item.fileType || ''
      if (!fileType && name.indexOf('.') >= 0) {
        fileType = name.slice(name.lastIndexOf('.') + 1).toLowerCase()
      }
      return {
        name: name,
        fileUid: String(fileUid),
        fileType: fileType,
        url: '/static/files/file/' + String(fileUid)
      }
    })
    .filter(Boolean)
}

function buildFormParams(params) {
  const empty = {
    uid: '',
    domainHost: '',
    fullName: '',
    shortName: '',
    intro: '',
    loginLogo: '',
    homeLogo: '',
    useSameLogo: true,
    userManuals: '',
    fileLists: {
      userManuals: [],
      loginLogo: [],
      homeLogo: []
    }
  }
  if (params.pageStatus === 'add') {
    return empty
  }
  const row = params.formValues || params.currentRow || {}
  if (!row || (!row.uid && !row.domainHost && !row.fileLists)) {
    return empty
  }
  const loginLogo = row.loginLogo || ''
  const homeLogo = row.homeLogo || ''
  const manuals =
    row.fileLists && Array.isArray(row.fileLists.userManuals)
      ? row.fileLists.userManuals
      : manualsToFileList(
          row.userManuals,
          params.state && params.state.baseURL,
          params.state && params.state.uploadfile
        )
  const loginList =
    row.fileLists && Array.isArray(row.fileLists.loginLogo)
      ? row.fileLists.loginLogo
      : loginLogo
        ? [
            {
              name: 'loginLogo.png',
              url: loginLogo,
              uid: 'loginLogo',
              status: 'success'
            }
          ]
        : []
  const homeList =
    row.fileLists && Array.isArray(row.fileLists.homeLogo)
      ? row.fileLists.homeLogo
      : homeLogo && homeLogo !== loginLogo
        ? [
            {
              name: 'homeLogo.png',
              url: homeLogo,
              uid: 'homeLogo',
              status: 'success'
            }
          ]
        : []
  return {
    uid: row.uid || '',
    domainHost: row.domainHost || '',
    fullName: row.fullName || '',
    shortName: row.shortName || '',
    intro: row.intro || '',
    loginLogo: loginLogo,
    homeLogo: homeLogo,
    useSameLogo:
      row.useSameLogo !== undefined
        ? !!row.useSameLogo
        : !homeLogo || homeLogo === loginLogo,
    userManuals: '',
    fileLists: {
      userManuals: manuals,
      loginLogo: loginList,
      homeLogo: homeList
    }
  }
}

function buildFields(params) {
  const useSame =
    params.formValues && params.formValues.useSameLogo !== undefined
      ? !!params.formValues.useSameLogo
      : true
  const fields = [
    {
      key: 'domainHost',
      label: '子域名地址',
      type: 'input',
      placeholder: '例如 wh.buildbee.cn',
      disabled: (item) => !!(item.formValues && item.formValues.uid),
      inputTip: (item) =>
        item.formValues && item.formValues.uid
          ? '子域名创建后不允许修改。'
          : '仅支持 *.buildbee.cn 一级子域名。创建后不可修改，保存时会尝试在阿里云添加 A 记录。'
    },
    {
      key: 'fullName',
      label: '系统全称',
      type: 'input',
      placeholder: '登录页显示的系统全称'
    },
    {
      key: 'shortName',
      label: '系统简称',
      type: 'input',
      placeholder: '首页侧栏显示的简称'
    },
    {
      key: 'intro',
      label: '功能简介',
      type: 'input',
      inputType: 'textarea',
      autosize: { minRows: 4, maxRows: 8 },
      placeholder: '登录页左侧系统功能简介'
    },
    {
      key: 'useSameLogo',
      label: '图标共用',
      type: 'checkbox',
      options: [
        {
          value: 'useSameLogo',
          label: '登录页和首页使用同一个 logo'
        }
      ]
    },
    {
      key: 'loginLogo',
      label: useSame ? '系统图标' : '登录页图标',
      type: 'upload',
      url: '#',
      listType: 'picture-card',
      autoUpload: false,
      showFilelist: true,
      limit: 1,
      accept: 'image/png,image/jpeg,image/jpg,image/webp',
      uploadtip: '上传后会自动等比缩小并居中放入方框。请使用 PNG / JPG。'
    }
  ]
  if (!useSame) {
    fields.push({
      key: 'homeLogo',
      label: '首页图标',
      type: 'upload',
      url: '#',
      listType: 'picture-card',
      autoUpload: false,
      showFilelist: true,
      limit: 1,
      accept: 'image/png,image/jpeg,image/jpg,image/webp',
      uploadtip: '不上传时首页将使用登录页图标；两处都不传则使用系统默认图标。'
    })
  }
  fields.push({
    key: 'userManuals',
    label: '用户操作手册',
    type: 'upload',
    url: (item) => item.state.uploadfile,
    listType: 'text',
    fileType: 'file',
    download: true,
    autoUpload: false,
    showFilelist: true,
    limit: 20,
    accept: '.doc,.docx,.pdf,.xls,.xlsx,.ppt,.pptx,.txt,.zip',
    uploadtip:
      '可上传多个手册文件（如 docx/pdf）。点击文件名可在线打开或下载查看，保存后供该域名登录用户在右上角「用户手册」中使用。'
  })
  return fields
}

const domainBrand = {
  domainBrand: {
    name: 'domainBrand',
    componentTypes: ['navigate', 'check', 'tables', 'stepForm'],
    addFun: 'domainBrand/addDomainBrand',
    editFun: 'domainBrand/editDomainBrand',
    getListFun: 'domainBrand/getDomainBrandList',
    deleteFun: 'domainBrand/deleteDomainBrand',
    detailPage: [
      {
        buttonName: '新增',
        name: 'domainBrand',
        type: 'stepForm',
        theme: 'domainBrand',
        step: 'domainBrandInfo',
        label: '新增域名配置'
      },
      {
        buttonName: '编辑',
        name: 'domainBrand',
        type: 'stepForm',
        theme: 'domainBrand',
        step: 'domainBrandInfo',
        label: '编辑域名配置',
        checkType: 'useRowData'
      }
    ],
    headButtons: () => setCheckButtons(['新增']),
    queryParams: {},
    selectData: [],
    indexColumn: false,
    deleteConfirm:
      '只会删除本系统中的名称、简介、图标和手册配置，不会修改阿里云 DNS。是否继续？',
    rowData: (params) => {
      const rows =
        (params.state &&
          params.state.domainBrand &&
          params.state.domainBrand.domainBrandRows) ||
        []
      return rows.map((row) => {
        const manuals = parseManuals(row.userManuals)
        const count = manuals.length
        return Object.assign({}, row, {
          manualCount: count,
          manualCountText: count ? count + '个文件' : '未配置',
          loginLogo: row.loginLogo || '',
          homeLogo: row.homeLogo || row.loginLogo || ''
        })
      })
    },
    columns: [
      { prop: 'domainHost', label: '子域名', minWidth: '160px' },
      {
        prop: 'fullName',
        label: '系统全称',
        minWidth: '200px',
        overflow: true
      },
      { prop: 'shortName', label: '系统简称', minWidth: '120px' },
      {
        prop: 'intro',
        label: '功能简介',
        minWidth: '220px',
        overflow: true
      },
      {
        prop: 'loginLogo',
        label: '登录页图标',
        width: '110px',
        type: 'image'
      },
      {
        prop: 'homeLogo',
        label: '首页图标',
        width: '110px',
        type: 'image'
      },
      {
        prop: 'manualCountText',
        label: '用户操作手册',
        width: '130px',
        drillDown: true
      },
      {
        prop: '',
        label: '操作',
        width: '160px',
        fixed: 'right',
        buttons: () => setTableButtons(['编辑', '删除'])
      }
    ],
    formParams: (params) => buildFormParams(params),
    formRules: {
      domainHost: [
        { required: true, message: '请填写子域名', trigger: 'blur' }
      ],
      fullName: [
        { required: true, message: '请填写系统全称', trigger: 'blur' }
      ],
      shortName: [
        { required: true, message: '请填写系统简称', trigger: 'blur' }
      ]
    },
    formData: (params) => ({
      card: '域名配置信息',
      bottomButtons: setFormButtons(['取消', '提交']),
      fields: buildFields(params)
    })
  }
}

export {
  domainBrand as default,
  parseManuals,
  manualsToFileList,
  manualsFromForm
}
